import { every } from 'lodash/fp';
import { ApplicationState } from '../../types';
import { WithCurrencyCode } from '../../types/selectors/selectorPropTypes';
import { getAvailabilityHash } from '../../utils/getAvailabilityHash';
import { getSelectedCityHotelsWithAvailableRooms } from '../hotels/selectors';
import { hasAvailabilityPricingCurrencyCode } from '../pricing/views/availabilityPricing';
import { getEndDate, getEndTimeUtc, getStartDate, getStartTimeUtc, getVoucherCode } from '../resourceOrder/selectors';

export const hasSelectedCityEnterprisesCurrencyCodeAvailabilities = (
    state: ApplicationState,
    { currencyCode }: WithCurrencyCode
) => {
    const enterpriseIds = getSelectedCityHotelsWithAvailableRooms(state);
    const startDate = getStartDate(state);
    const endDate = getEndDate(state);
    const startTimeUtc = getStartTimeUtc(state);
    const endTimeUtc = getEndTimeUtc(state);
    const voucherCode = getVoucherCode(state);
    return every((enterpriseId) => {
        const availabilityHash =
            startDate != null && endDate != null
                ? getAvailabilityHash({
                      startDate: startTimeUtc ?? startDate,
                      endDate: endTimeUtc ?? endDate,
                      voucherCode,
                      enterpriseId,
                  })
                : null;
        return (
            availabilityHash != null && hasAvailabilityPricingCurrencyCode(state, { currencyCode, availabilityHash })
        );
    }, enterpriseIds);
};
